import { SxProps } from "@mui/system";
import colors from "../../theme/Colours";

export const containerStyle: SxProps = {
  borderRadius: "4px",
  backgroundColor: "white",
  border: `1px solid ${colors.ledgerCustomerPaginationBox}`,
};

export const searchAndSortContainer: SxProps = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "18px 24px",
  gap: 2,
  borderBottom: `1px solid ${colors.ledgerCustomerPaginationBox}`,
};

export const searchFieldStyle: SxProps = {
  width: "200px",
  height: "38px",
  "& .MuiOutlinedInput-root": {
    borderRadius: "4px",
    backgroundColor: colors.background2,
    fontSize: "14px",
    fontFamily: "Poppins, sans-serif",
    paddingLeft: "8px",
    boxShadow: "none",
    "& fieldset": {
      borderColor: colors.searchInputBorder,
    },
    "&:hover fieldset": {
      borderColor: colors.searchInputBorder,
    },
    "&.Mui-focused fieldset": {
      borderColor: colors.searchInputBorder,
    },
  },
  "& .MuiInputBase-input": {
    padding: "10px 12px 10px 0",
  },
  "& .MuiInputBase-input::placeholder": {
    color: colors.searchInputText,
    fontWeight: 500,
    opacity: 1,
  },
};

export const checkDetailsStyles = {
  background: colors.checkDetailsButton,
  color: "black",
  width: "100%",
  border: `1px solid ${colors.buttonBGColor}`,
  padding: "6px 10px",
  borderRadius: "60px",
  cursor: "pointer",
  fontSize: "12px",
};

export const mainContentStyle: SxProps = {
  minHeight: "553px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
};

export const paginationContainerStyle: SxProps = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginTop: "12px",
  backgroundColor: colors.background2,
  padding: "12px 24px",
  border: `1px solid ${colors.ledgerCustomerPaginationBox}`,
};

export const paginationCaptionStyle: SxProps = {
  color: colors.paginationCaption,
  fontFamily: "Poppins, sans-serif",
  fontWeight: 500,
};

export const addCustomerButtonStyle: SxProps = {
  backgroundColor: colors.primaryButtonOrange,
  color: colors.background2,
  border: "none",
  borderRadius: "4px",
  padding: "10px 14px",
  fontFamily: "Poppins, sans-serif",
  fontSize: "14px",
  fontWeight: 500,
  cursor: "pointer",
  whiteSpace: "nowrap",
  height: "40px",
};

export const downloadCsvButtonStyle: SxProps = {
  display: "flex",
  alignItems: "center",
  gap: "6px",
  color: colors.searchInputText,
  fontWeight: 500,
  backgroundColor: colors.background2,
  border: `1px solid ${colors.greyBackground}`,
  borderRadius: "4px",
  padding: "8px 12px",
  fontSize: "14px",
  fontFamily: "Poppins, sans-serif",
  cursor: "pointer",
  boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
  height: "40px",
};

export const downloadIconStyle: React.CSSProperties = {
  width: "16px",
  height: "16px",
  marginRight: "8px",
};

export const SortBYContainerStyle: SxProps = { borderRadius: "4px" };

export const DateRangeContainerStyle: SxProps = {
  borderRadius: "4px",
  padding: "3px 8px",
};

export const customersNameStyle: SxProps = {
  cursor: "pointer",
};

export const grandTotalStyle: SxProps = {
  fontFamily: "Poppins",
  fontWeight: "600",
  fontSize: {
    xs: "14px",
    sm: "16px",
  },
  color: "#3578FD",
  whiteSpace: "nowrap",
};

export const grandTotalAmountStyle = (positive: boolean) =>
  ({
    ...grandTotalStyle,
    color: positive ? "#00B207" : "#FF0000",
  }) as SxProps;

export const downloadSelectStyle: SxProps = {
  height: "40px",
  fontFamily: "Poppins, sans-serif",
  fontSize: "12px",
  fontWeight: 600,
  color: colors.searchInputText,
  backgroundColor: colors.background2,
  borderRadius: "4px",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: colors.searchInputBorder,
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: colors.searchInputBorder,
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: colors.searchInputBorder,
  },
};

export const downloadMenuPropsStyle = {
  PaperProps: {
    sx: {
      borderRadius: "4px",
      border: `1px solid ${colors.searchInputBorder}`,
      boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
      mt: "4px",
      "& .MuiMenuItem-root": {
        fontFamily: "Poppins, sans-serif",
        fontSize: "12px",
        fontWeight: 500,
        color: colors.searchInputText,
        padding: "6px 16px",
      },
      "& .MuiMenuItem-root:hover": {
        backgroundColor: "#eeeeee",
      },
    },
  },
};
